import React, { createContext, useContext } from 'react';

import type { VgpsLivekitWebRuntime } from '../core/runtime/types';

const VgpsRuntimeContext = createContext<VgpsLivekitWebRuntime | null>(null);

export interface VgpsLivekitProviderProps {
  runtime: VgpsLivekitWebRuntime;
  children: React.ReactNode;
}

export function VgpsLivekitProvider({ runtime, children }: VgpsLivekitProviderProps): JSX.Element {
  return <VgpsRuntimeContext.Provider value={runtime}>{children}</VgpsRuntimeContext.Provider>;
}

export function useRuntimeContext(): VgpsLivekitWebRuntime | null {
  return useContext(VgpsRuntimeContext);
}